// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"09fc42a2","193":"c25a8c16","628":"3d18beda","659":"efac9475","749":"2751dee1"}[chunkId] + ".chunk.css";
};